import { metricKeys } from '@pulse/metrics';

export const networkRequestUrlDimensions = {
  host: 'network_request_url_host',
  path: 'network_request_url_path',
  query: 'network_request_url_query',
};

export const rcaMetrics = [metricKeys.AverageRequestDuration];

export const compositeNetworkRequestUrlDimension = 'network_api_calls';

export const genNetworkRequestUrl = (item) => {
  const host = item[networkRequestUrlDimensions.host] ?? '*';
  const path = item[networkRequestUrlDimensions.path] ?? '/*';
  const query = item[networkRequestUrlDimensions.query] ?? '';
  return `${host}${path}${query}`;
};

export const genHints = (item, rcaData) => {
  if (!rcaData) {
    return [];
  }
  const rcaRes = rcaData.find(
    (d) =>
      d.outlier[`event.${networkRequestUrlDimensions.host}`] ===
        item[networkRequestUrlDimensions.host] &&
      d.outlier[`event.${networkRequestUrlDimensions.path}`] ===
        item[networkRequestUrlDimensions.path] &&
      d.outlier[`event.${networkRequestUrlDimensions.query}`] ===
        item[networkRequestUrlDimensions.query],
  );
  return rcaRes?.algorithms ?? [];
};

export const hintColorMap = {
  Outlier: '#0046FF',
  'Worse in Impacted': '#08979C',
};
